import { handleActions } from 'redux-actions';
import { actions } from '../../actions/messaging';
export const { messagingGetApps, messagingSetApps, messagingAddApp, messagingDeleteApp, messagingGetHooks, messagingSetHooks, messagingAddPage, messagingDeletePage, messagingDeleteInstagramAccount, messagingUpdatePage, messagingSetAsyncStatus, messagingUpdateAccessToken, messagingUpdateInstagramPage, } = actions;
const initialState = {
    appList: [],
    callbackUrl: '',
    verificationToken: '',
    meta: {
        asyncStatus: 'loading',
    },
};
export const messaging = handleActions({
    [messagingSetApps.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { appList: action.payload.applications, meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [messagingSetHooks.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { callbackUrl: action.payload.callback_url, verificationToken: action.payload.verification_token });
    },
    [messagingSetAsyncStatus.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: action.payload.status }) });
    },
}, initialState);
